import { differenceWith, isEqual } from "lodash";

/**
 * Returns an object containing the changes between two objects.
 * @param {Object} newObj - The new object.
 * @param {Object} oldObj - The old object.
 * @param {Array} ignoreKeys - An array of keys to ignore during comparison.
 * @returns {Object} - An object containing the changes between the two objects.
 */
export const getObjectChanges = (newObj, oldObj, ignoreKeys) => {
  const changes = {};

  for (const key in newObj) {
    if (ignoreKeys?.includes(key)) continue;
    // if the key is an array, we need to check the changes in the array
    if (Array.isArray(newObj[key])) {
      // if the length of the array is different
      if (newObj[key]?.length !== oldObj[key]?.length) {
        changes[key] = { old: oldObj[key], new: newObj[key] };
      }

      // if the array is the same length, we need to iterate through the array and check the changes
      if (newObj[key]?.length === oldObj[key]?.length) {
        const diff = differenceWith(newObj[key], oldObj[key], isEqual);

        if (diff.length > 0) {
          changes[key] = { old: oldObj[key], new: newObj[key] };
        }
      }
    } else if (newObj[key] !== oldObj[key]) {
      changes[key] = { old: oldObj[key], new: newObj[key] };
    }
  }
  return changes;
};
